const Tech = () => {
  const techImages = [
    // Languages & Frameworks
    { name: 'React', src: '/assets/tech/react.png', height: '65px' },
    { name: 'Next.js', src: '/assets/tech/nextjs.png', height: '57px' },
    { name: 'Node.js', src: '/assets/tech/nodejs.png', height: '55px' },
    { name: 'Tailwind CSS', src: '/assets/tech/tailwindcss.png', height: '70px' },

    // Platforms
    { name: 'Firebase', src: '/assets/tech/firebase.png', height: '65px' },
    { name: 'Supabase', src: '/assets/tech/supabase.png', height: '65px' },
    { name: 'Vercel', src: '/assets/tech/vercel.png', height: '80px' },
    { name: 'Netlify', src: '/assets/tech/netlify.png', height: '60px' },

    // Mobile / OS
    { name: 'Flutter', src: '/assets/tech/flutter.png', height: '45px' },
    { name: 'Android', src: '/assets/tech/android.png', height: '75px' },
    { name: 'iOS', src: '/assets/tech/ios.png', height: '45px' },
  ];

  // duplicate items
  const duplicatedTech = [...techImages, ...techImages];

  return (
    <section id="skills" className="py-24 bg-[rgb(4,4,4)] overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-4xl sm:text-5xl font-light text-white text-center mb-16">
          Familiar With
        </h2>

        <div className="relative w-full overflow-hidden">
          <div className="marquee">
            <div className="marquee-content">
              {duplicatedTech.map((tech, index) => (
                <div
                  key={index}
                  className="flex-shrink-0 flex items-center justify-center p-6 group cursor-pointer"
                  style={{ minWidth: '140px' }}
                >
                  <img
                    src={tech.src}
                    alt={tech.name}
                    className="object-contain group-hover:grayscale-0 transition-all duration-300"
                    style={{ width: tech.width, height: tech.height }}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .marquee {
          width: 100%;
          overflow: hidden;
          position: relative;
        }

        .marquee-content {
          display: flex;
          width: max-content;
          animation: scroll 50s linear infinite;
        }

        .marquee-content:hover {
          animation-play-state: paused;
        }

        @keyframes scroll {
          from {
            transform: translateX(0);
          }

          to {
            transform: translateX(-50%);
          }
        }
      `}</style>
    </section>
  );
};

export default Tech;